/* Ube Daily theme scripts — no dependencies */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const overlay = () => $('[data-drawer-overlay]');

  /* ---------- Drawers (mobile menu + cart) ---------- */
  // Closed drawers are inert so hidden links are not focusable (accessibility)
  $$('.mobile-menu, .cart-drawer').forEach((el) => { if (!el.classList.contains('is-open')) el.inert = true; });
  let lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    el.inert = false;
    const ov = overlay();
    if (ov) ov.hidden = false;
    document.body.classList.add('is-locked');
    const focusable = el.querySelector('button, a, input');
    if (focusable) setTimeout(() => focusable.focus(), 50);
  }
  function closeDrawers() {
    $$('.mobile-menu.is-open, .cart-drawer.is-open').forEach((el) => {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      el.inert = true;
    });
    const ov = overlay();
    if (ov) ov.hidden = true;
    document.body.classList.remove('is-locked');
    $$('[data-menu-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t.closest('[data-menu-open]')) {
      t.closest('[data-menu-open]').setAttribute('aria-expanded', 'true');
      openDrawer($('[data-mobile-menu]'));
    } else if (t.closest('[data-menu-close]') || t.closest('[data-cart-close]') || t.matches('[data-drawer-overlay]')) {
      closeDrawers();
    } else if (t.closest('[data-cart-open]') && window.theme && window.theme.cartDrawer && $('#CartDrawer')) {
      e.preventDefault();
      openDrawer($('#CartDrawer'));
    } else if (t.closest('[data-search-open]')) {
      const panel = $('[data-search-panel]');
      if (panel) { panel.hidden = !panel.hidden; if (!panel.hidden) $('input', panel).focus(); }
    } else if (t.closest('[data-search-close]')) {
      const panel = $('[data-search-panel]');
      if (panel) panel.hidden = true;
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeDrawers();
      const panel = $('[data-search-panel]');
      if (panel) panel.hidden = true;
    }
  });

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    const value = (cents / 100);
    const withDelim = (n, dec, thousands, decimal) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelim(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelim(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelim(value, 0, '.', ',');
        default: return withDelim(value, 2, ',', '.');
      }
    });
  }

  /* ---------- Cart (AJAX) ---------- */
  async function refreshCartDrawer(open) {
    try {
      const res = await fetch(`${window.theme.routes.root_url.replace(/\/$/, '')}/?sections=cart-drawer`);
      const data = await res.json();
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = html.querySelector('[data-cart-drawer-content]');
      const current = $('[data-cart-drawer-content]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      const cart = await (await fetch('/cart.js')).json();
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      if (open) openDrawer($('#CartDrawer'));
    } catch (err) { console.error(err); }
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-qty]');
    if (!btn) return;
    btn.disabled = true;
    await fetch(window.theme.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: btn.dataset.key, quantity: Math.max(0, parseInt(btn.dataset.cartQty, 10)) })
    });
    refreshCartDrawer(false);
  });

  /* ---------- Product form ---------- */
  $$('[data-product-section]').forEach((section) => {
    const form = $('[data-product-form]', section);
    if (!form) return;
    const idInput = $('[data-variant-input]', form);
    const atc = $('[data-atc]', form);
    const atcText = $('[data-atc-text]', form);
    const priceNow = $('[data-price-now]', section);
    const priceWas = $('[data-price-was]', section);
    const stock = $('[data-stock]', section);
    const stockText = $('[data-stock-text]', section);
    const errorBox = $('[data-form-error]', form);
    const stickyPrice = $('[data-sticky-price]', section);
    const stickyBtn = $('[data-sticky-btn]', section);
    const addLabel = atcText ? atcText.textContent.split('—')[0].trim() : 'Add to cart';

    // Pack (variant) selector
    $$('[data-packs] input[type="radio"]', form).forEach((radio) => {
      radio.addEventListener('change', () => {
        $$('.pack', form).forEach((p) => p.classList.toggle('is-selected', p.contains(radio)));
        idInput.value = radio.value;
        const available = radio.dataset.available === 'true';
        if (priceNow) priceNow.textContent = radio.dataset.price;
        if (stickyPrice) stickyPrice.textContent = radio.dataset.price;
        if (priceWas) { priceWas.textContent = radio.dataset.compare; priceWas.hidden = !radio.dataset.compare; }
        if (atc) atc.disabled = !available;
        if (stickyBtn) stickyBtn.disabled = !available;
        if (atcText) atcText.textContent = available ? `${addLabel} — ${radio.dataset.price}` : 'Sold out';
        if (stock) stock.classList.toggle('stock--out', !available);
        if (stockText) stockText.textContent = available ? 'In stock' : 'Sold out';
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url.toString());
      });
    });

    // Quantity
    const qty = $('[data-qty-input]', form);
    const minus = $('[data-qty-minus]', form);
    const plus = $('[data-qty-plus]', form);
    if (minus) minus.addEventListener('click', () => { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', () => { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

    // Add to cart
    form.addEventListener('submit', async (e) => {
      if (!(window.theme && window.theme.cartDrawer)) return;
      e.preventDefault();
      if (errorBox) errorBox.hidden = true;
      atc.classList.add('is-loading');
      try {
        const res = await fetch(window.theme.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        await refreshCartDrawer(true);
      } catch (err) {
        if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
      } finally {
        atc.classList.remove('is-loading');
      }
    });

    // Sticky add-to-cart
    const sticky = $('[data-sticky-atc]', section);
    if (sticky && atc && 'IntersectionObserver' in window) {
      sticky.inert = true;
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.inert = !show;
      }).observe(atc);
      if (stickyBtn) stickyBtn.addEventListener('click', () => atc.click());
    }

    // Share
    const share = $('[data-share]', section);
    if (share) {
      share.addEventListener('click', async () => {
        const url = share.dataset.url;
        if (navigator.share) {
          try { await navigator.share({ title: share.dataset.title, url }); } catch (_) {}
        } else if (navigator.clipboard) {
          await navigator.clipboard.writeText(url);
          const label = $('[data-share-label]', share);
          if (label) { const old = label.textContent; label.textContent = 'Link copied'; setTimeout(() => (label.textContent = old), 2000); }
        }
      });
    }
  });

  /* ---------- Product gallery ---------- */
  $$('[data-gallery]').forEach((gallery) => {
    const track = $('[data-gallery-track]', gallery);
    if (!track) return;
    const slides = $$('.gallery__slide', track);
    const thumbs = $$('[data-thumb]', gallery);
    const dots = $$('.gallery__dots span', gallery);
    const goTo = (i) => {
      const idx = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
    };
    const current = () => Math.round(track.scrollLeft / track.clientWidth);
    const sync = () => {
      const i = current();
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
    };
    let raf;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(parseInt(t.dataset.thumb, 10))));
    const prev = $('[data-gallery-prev]', gallery);
    const next = $('[data-gallery-next]', gallery);
    if (prev) prev.addEventListener('click', () => goTo(current() - 1));
    if (next) next.addEventListener('click', () => goTo(current() + 1));
  });

  /* ---------- Carousels ---------- */
  $$('[data-carousel]').forEach((c) => {
    const track = $('[data-carousel-track]', c);
    if (!track) return;
    const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 12 : 200);
    const prev = $('[data-carousel-prev]', c);
    const next = $('[data-carousel-next]', c);
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  /* ---------- UGC video play ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ugc-play]');
    if (!btn) return;
    const card = btn.closest('.ugc-card');
    const video = card && card.querySelector('video');
    if (!video) return;
    if (video.paused) { video.muted = false; video.play(); card.classList.add('is-playing'); video.setAttribute('controls', ''); }
    else { video.pause(); card.classList.remove('is-playing'); }
  });

  /* ---------- Tabs ---------- */
  $$('[data-tabs]').forEach((wrap) => {
    const tabs = $$('[role="tab"]', wrap);
    const panels = $$('[role="tabpanel"]', wrap);
    const select = (i, focus) => {
      tabs.forEach((t, n) => { t.setAttribute('aria-selected', n === i); t.tabIndex = n === i ? 0 : -1; });
      panels.forEach((p, n) => { p.hidden = n !== i; });
      if (focus) tabs[i].focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(i));
      t.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') select((i + 1) % tabs.length, true);
        if (e.key === 'ArrowLeft') select((i - 1 + tabs.length) % tabs.length, true);
      });
    });
  });

  /* ---------- Announcement rotation (mobile) ---------- */
  $$('.announcement__items').forEach((list) => {
    const items = $$('li', list);
    if (items.length < 2) return;
    let i = 0;
    list.classList.add('is-rotating');
    items[0].classList.add('is-active');
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 3500);
  });


  /* ---------- Motion: header state, scroll progress, reveal on scroll ---------- */
  (function motion() {
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const designMode = window.Shopify && window.Shopify.designMode;
    const header = $('.header');
    const bar = document.createElement('div');
    bar.className = 'scroll-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    let ticking = false;
    const onScroll = () => {
      const y = window.scrollY || window.pageYOffset;
      if (header) header.classList.toggle('is-scrolled', y > 12);
      const max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.setProperty('--progress', max > 0 ? Math.min(1, y / max).toFixed(4) : 0);
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
    // First measurement after layout settles, so it never forces a synchronous reflow
    window.requestAnimationFrame(() => window.requestAnimationFrame(onScroll));

    if (reduce || designMode || !('IntersectionObserver' in window)) return;
    const selectors = [
      '.main .section-head', '.recipe-cats__intro', '.cat-card', '.banner', '.benefits-split__copy',
      '.benefits-split__image', '.icon-item', '.ugc-card', '.story__grid', '.healthier__grid',
      '.journal__intro', '.article-card', '.faq__intro', '.faq-item', '.feature-strip li', '.tabs__intro',
      '.tab-card', '.compare__head', '.table-scroll', '.product-card', '.page-hero__grid > *',
      '.newsletter__inner > *', '.reviews__head', '.article-main__head', '.article-cta',
      '.prose-block', '.page-main__intro', '.footer__grid > *', '.footer__wordmark', '.article-main__content > h2', '.article-main__content > table', '.article-main__content > blockquote'
    ];
    const els = $$(selectors.join(','));
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const el = entry.target;
          el.classList.add('is-revealed');
          io.unobserve(el);
          const delay = parseFloat(el.style.getPropertyValue('--reveal-delay')) || 0;
          setTimeout(() => {
            el.removeAttribute('data-reveal');
            el.classList.remove('is-revealed');
            el.style.removeProperty('--reveal-delay');
          }, 900 + delay * 1000);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    const counters = new Map();
    els.forEach((el) => {
      const parent = el.parentElement && el.parentElement.closest('ul, .container, section') || el.parentElement;
      const n = counters.get(parent) || 0;
      counters.set(parent, n + 1);
      el.style.setProperty('--reveal-delay', Math.min(n, 6) * 0.08 + 's');
      el.setAttribute('data-reveal', '');
      io.observe(el);
    });
  })();

  window.UbeDaily = { formatMoney, refreshCartDrawer };
})();
